import React from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import Educational from "../components/Layouts/Sidebar/Left/Settings/Educational";
import Employment from "../components/Layouts/Sidebar/Left/Settings/Employment";
import Interest from "../components/Layouts/Sidebar/Left/Settings/Interest";
import Personal from "../components/Layouts/Sidebar/Left/Settings/Personal";
import Report from "../components/Layouts/Sidebar/Left/Settings/Report";
import Security from "../components/Layouts/Sidebar/Left/Settings/Security";

const SettingsHome = () => {
  return (
    <>
      <div className="row justify-content-between  m-3 card-bg1 card">
        <h5 className="text-warning fw-bold py-3 head-line">Settings</h5>

        <Tab.Container
          id="left-tabs-example"
          defaultActiveKey="first"
          className=""
        >
          <div className="row my-3">
            <div className="col-md-3">
              <Nav variant="pills" className="flex-column">
                <Nav.Item className="mb-3 NavBtn">
                  <Nav.Link eventKey="first">Personal</Nav.Link>
                </Nav.Item>
                <Nav.Item className="mb-3 NavBtn">
                  <Nav.Link eventKey="second">Educational</Nav.Link>
                </Nav.Item>
                <Nav.Item className="mb-3 NavBtn">
                  <Nav.Link eventKey="third">Employment</Nav.Link>
                </Nav.Item>
                <Nav.Item className="mb-3 NavBtn">
                  <Nav.Link eventKey="four">Interest</Nav.Link>
                </Nav.Item>
                <Nav.Item className="mb-3 NavBtn">
                  <Nav.Link eventKey="five">Security</Nav.Link>
                </Nav.Item>
                {/*<Nav.Item className="mb-3 NavBtn">
                        <Nav.Link eventKey="six">Report</Nav.Link>
                        </Nav.Item> */}
              </Nav>
            </div>
            <div className="col-md-9 custom-das-border">
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <Personal />
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <Educational />
                </Tab.Pane>
                <Tab.Pane eventKey="third">
                  <Employment />
                </Tab.Pane>
                <Tab.Pane eventKey="four">
                  <Interest />
                </Tab.Pane>
                <Tab.Pane eventKey="five">
                  <Security />
                </Tab.Pane>
                <Tab.Pane eventKey="six">
                  <Report />
                </Tab.Pane>
              </Tab.Content>
            </div>
          </div>
        </Tab.Container>
      </div>
      
    </>
  );
};

export default SettingsHome;
